/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSuppressionInformation } from '../fn/mailing-list-resubscribe-page/get-suppression-information';
import { GetSuppressionInformation$Params } from '../fn/mailing-list-resubscribe-page/get-suppression-information';
import { SuppressionDto as PlatformSuppressionDto } from '../models/platform/suppression-dto';
import { resubscribe } from '../fn/mailing-list-resubscribe-page/resubscribe';
import { Resubscribe$Params } from '../fn/mailing-list-resubscribe-page/resubscribe';

@Injectable({ providedIn: 'root' })
export class MailingListResubscribePageClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mailingListResubscribePageGetSuppressionInformation()` */
  static readonly MailingListResubscribePageGetSuppressionInformationPath = '/mailing-list-resubscribe-page';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSuppressionInformation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSuppressionInformation$Response(params: GetSuppressionInformation$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformSuppressionDto | undefined>> {
    const obs = getSuppressionInformation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSuppressionInformation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSuppressionInformation(params: GetSuppressionInformation$Params, context?: HttpContext): Observable<PlatformSuppressionDto | undefined> {
    const resp = this.getSuppressionInformation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlatformSuppressionDto | undefined>): PlatformSuppressionDto | undefined => r.body)
    );
  }

  /** Path part for operation `mailingListResubscribePageResubscribe()` */
  static readonly MailingListResubscribePageResubscribePath = '/mailing-list-resubscribe-page';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resubscribe()` instead.
   *
   * This method doesn't expect any request body.
   */
  resubscribe$Response(params: Resubscribe$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = resubscribe(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resubscribe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resubscribe(params: Resubscribe$Params, context?: HttpContext): Observable<void> {
    const resp = this.resubscribe$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
